import { APPLICATION } from "#/constants";
import { request } from "#/utils/request";

interface ProductData {
  data: IProduct[];
  error: string;
}

export interface IProduct {
  idProduto: number;
  idSubProduto: number;
  nomeProduto: string;
  /** identificador único do produto no catálogo, usado para navegação/telas (idProduto/idSubProduto podem se repetir entre produtos) */
  idComercial: number;
  iconAndroid: string;
  iconIos: string;
  title: string;
  text: string;
  newProduct: boolean;
}

/** Endpoints */
const getProductsEndpoint = (codigoComissionado: string) =>
  `/product?codigoComissionado=${codigoComissionado}`;

/**
 * @function find - GET Data
 * @param id - identity
 */
export const findProductsByCommissioned = async (codigoComissionado: string) =>
  (
    await request.get<ProductData>(getProductsEndpoint(codigoComissionado), {
      baseURL: APPLICATION.KONG_URL_V2,
    })
  ).data;
